// extracted by mini-css-extract-plugin
export var homeSection = "pageTemplate-module--homeSection--d3c97";